(function () {
  document.querySelectorAll('.drv-lrec').forEach(function (root) {
    const track = root.querySelector('[data-drv-lrec-track]');
    const slider = root.querySelector('[data-drv-lrec-slider]');
    const foot = root.querySelector('.drv-lrec__foot');
    const cards = track ? track.querySelectorAll('.drv-lrec__card') : [];
    if (!track || !cards.length) {
      if (foot) foot.classList.add('is-idle');
      return;
    }

    function step() {
      const gap = parseFloat(getComputedStyle(track).gap) || 24;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function stops() {
      if (maxScroll() < 2) return 1;
      const gap = parseFloat(getComputedStyle(track).gap) || 24;
      const visible = Math.max(1, Math.floor((track.clientWidth + gap + 1) / step()));
      return Math.max(1, cards.length - visible + 1);
    }
    function activeIndex() {
      if (maxScroll() - track.scrollLeft < 2) return segs.length - 1;
      return Math.min(segs.length - 1, Math.max(0, Math.round(track.scrollLeft / step())));
    }

    let segs = [];
    const segLabel = slider ? slider.dataset.drvLrecSegLabel : '';
    function buildSegs() {
      const n = stops();
      if (n === segs.length) return;
      slider.innerHTML = '';
      segs = [];
      if (n < 2) return;
      for (let i = 0; i < n; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'drv-lrec__seg';
        if (segLabel) b.setAttribute('aria-label', segLabel.replace('[index]', String(i + 1)));
        b.addEventListener('click', function () {
          track.scrollTo({ left: Math.min(i * step(), maxScroll()), behavior: 'smooth' });
        });
        slider.appendChild(b);
        segs.push(b);
      }
    }

    function update() {
      buildSegs();
      slider.hidden = segs.length < 2;
      const i = activeIndex();
      segs.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      if (foot) foot.classList.toggle('is-idle', maxScroll() < 2);
    }

    track.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    update();

    const prev = root.querySelector('[data-drv-lrec-prev]');
    const next = root.querySelector('[data-drv-lrec-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    let down = false, x0 = 0, s0 = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('a, button')) return;
      e.preventDefault();
      down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none';
      try { track.setPointerCapture(e.pointerId); } catch (err) { return; }
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      const dx = e.clientX - x0;
      if (Math.abs(dx) > 5) moved = true;
      track.scrollLeft = s0 - dx;
    });
    function endDrag(e) {
      if (!down) return;
      down = false;
      track.style.cursor = '';
      if (track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) track.releasePointerCapture(e.pointerId);
      const i = Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / step())));
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
      const done = function () { track.style.scrollSnapType = ''; update(); };
      if ('onscrollend' in track) track.addEventListener('scrollend', done, { once: true });
      else setTimeout(done, 700);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) {
      if (!moved) return;
      moved = false; e.preventDefault(); e.stopPropagation();
    }, true);
  });
})();
